/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/application_flow';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "CreateApplicationFlowRequest": {
                    "fields": {
                      "idempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreateApplicationFlowResponse": {
                    "fields": {
                      "applicationFlow": {
                        "type": ".squareup.sfs.external.models.ApplicationFlow",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CreateApplicationFlowRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CreateApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Response will be based on the currently authorized Multipass person.
 * --
 *
 * SOURCE CreateApplicationFlowRequest @ squareup/sfs/external/services/application_flow/create_application_flow.proto at 12:1
 */
export const CreateApplicationFlowRequest = $root.lookupType('squareup.sfs.external.service.CreateApplicationFlowRequest');
fixType(CreateApplicationFlowRequest, {
  idempotencyKey: {
    required: true
  }
});
Builder.createAndAttachToType(CreateApplicationFlowRequest);
/**
 * SOURCE CreateApplicationFlowResponse @ squareup/sfs/external/services/application_flow/create_application_flow.proto at 19:1
 */
export const CreateApplicationFlowResponse = $root.lookupType('squareup.sfs.external.service.CreateApplicationFlowResponse');
fixType(CreateApplicationFlowResponse, {
  applicationFlow: {
    required: true
  }
});
Builder.createAndAttachToType(CreateApplicationFlowResponse);